/**
 * Mirrors the backend's placeholder substitution (Processing/ReplySender.RenderTemplate), so the
 * preview an admin sees is exactly what the follower will receive. Shared by the trigger editor
 * and the manual reply confirmation — the two must never drift apart.
 */
export const renderTemplate = (
  template: string,
  link: string | null | undefined,
  username = "ivan_petrov",
) =>
  template
    .replaceAll("{link}", link ?? "")
    .replaceAll("{username}", username)
    .replaceAll("{newLine}", "\n");
